/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import LoadingImage from "../img/FengLoaderPNGFull.png";
import Lottie from "react-lottie";

import { Modal } from "reactstrap";
import { QRCodeSVG } from 'qrcode.react';
import { CustomButton } from "../home/main/home-layout-draggable-columns/custom-button";
import {
  createQRcode,
} from "../../api";
import { useTranslation } from "react-i18next";



export const ModalPreview = ({ isOpen, onClose, templateID, templateName, storeKey }) => {
  const { t } = useTranslation();
  
  const [isDeeplinkLoaded, setIsDeeplinkLoaded] = useState(false); // Loading state
  const [qrCodeValue, setQrCodeValue] = useState(`fengcart://content?=${templateID}&${templateName}`); 

  const customLoaderJson = `{"v":"5.5.5","fr":25,"ip":0,"op":79,"w":300,"h":150,"nm":"Loading-2","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"icon 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":39,"s":[-90]},{"t":79,"s":[270]}],"ix":10},"p":{"a":0,"k":[150,75,0],"ix":2},"a":{"a":0,"k":[53,53,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,-15.464],[15.464,0],[0,15.464],[-15.464,0]],"o":[[0,15.464],[-15.464,0],[0,-15.464],[15.464,0]],"v":[[28,0],[0,28],[-28,0],[0,-28]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.09411764705882353,0.4196078431372549,0.984313725490196,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":10,"ix":5},"lc":2,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[53,53],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":51,"s":[0]},{"t":79,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":39,"s":[0]},{"t":64,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":39,"op":79,"st":39,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"icon","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[-90]},{"t":40,"s":[270]}],"ix":10},"p":{"a":0,"k":[150,75,0],"ix":2},"a":{"a":0,"k":[53,53,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,-15.464],[15.464,0],[0,15.464],[-15.464,0]],"o":[[0,15.464],[-15.464,0],[0,-15.464],[15.464,0]],"v":[[28,0],[0,28],[-28,0],[0,-28]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.09411764705882353,0.4196078431372549,0.984313725490196,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":10,"ix":5},"lc":2,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[53,53],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":12,"s":[0]},{"t":40,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":25,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":40,"st":0,"bm":0}],"markers":[]}`

  useEffect(() => {
    loadEncryptedData();
  }, []);

  // Update Current Theme
  const loadEncryptedData = () => {
    setIsDeeplinkLoaded(false);
    // API
    createQRcode(storeKey, templateID)
      .then((response) => {
        const data = response.data.data;
        const fetchedTemplateID = data.tid;
        const fetchedStoreKey = data.sk;
        const fetchedAt = data.at;
        const fetchedURI = data.uri;
        if (data) {
          const newQrCodeValue = `fengcart://content?sk=${fetchedStoreKey}&tid=${fetchedTemplateID}&at=${fetchedAt}&uri=${fetchedURI}`;

          setQrCodeValue(newQrCodeValue);
          setIsDeeplinkLoaded(true);
        }
      })
      .catch((error) => {
        console.error("Error fetching navBar data:", error);
      });
  };

  const getLoaderAnimation = (customLoaderJson) => {
    return JSON.parse(customLoaderJson);
};

const LoaderAnimattion = (props) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: getLoaderAnimation(
      props.customLoaderJson
    ),
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const animationStyle = {
    margin: "190px auto auto 60px",
    zIndex: 5000,
  };

  return (
    <Lottie
      options={defaultOptions}
      height={"250px"}
      width={"250px"}
      style={animationStyle}
    />
  );
};

  return (
    <Modal
      isOpen={isOpen}
      className="transitionSelector preview previewModal isOpen"
    >
      <section>
        <div className="modal__container">
          <div className="row">
            <div className="modal__title primary">{t("homeModalPreview.title")}</div>
            <div className="modal__buttons">
            <CustomButton  type="HOWTO" label={t("homeModalPreview.buttonPreview")} href="https://fengcart.com/how-to-preview-store" />
            <p> &nbsp;&nbsp;&nbsp;</p>
              <button
                type="button"
                className="close__button custom-button cancel-button"
                onClick={onClose}
              >{t("buttons.close")}</button>
              
            </div>
          </div>
          <div className="body__modal">
          {isDeeplinkLoaded ? (
              <div className="modal__container-image">
                <QRCodeSVG
                  value={qrCodeValue}
                  size={420}
                  bgColor={"#FFFFFF"}
                  fgColor={"#104B9E"}
                  level={"H"}
                  includeMargin={true}
                  marginSize={20}
                  imageSettings={{
                    src: LoadingImage,
                    x: undefined,
                    y: undefined,
                    height: 90,
                    width: 120,
                    excavate: true,
                  }}
                />
                <p className="textPreview">
                  {t("homeModalPreview.scanText")
                                      .split("<br />")
                                      .map((line, index) => (
                                        <React.Fragment key={index}>
                                          <a>{line}</a>
                                          <br />
                                        </React.Fragment>
                                      ))}  <strong> “{templateName}” </strong> 
                </p>                
              </div>
            ) : (
              <p className="textPreview" style={{height: "550px"}}>Generating QR...
              <div className="loading-content-theme ">
              <div className="loading-container-theme">
              <LoaderAnimattion
selectedLoader={true}
customLoaderJson={customLoaderJson}
/>
              </div>                     
            </div></p>
            )}
          </div>
        </div>
      </section>
    </Modal>
  );
};
